module.exports = __webpack_public_path__ + "ed4df45d4dade7201f4f3e3597a1900a.png";